<template>
	<div>
		<div v-if="showadvancedsearch">
			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("programme") }}</label>
						<select class="form-control" v-model="search.programme" @change="callUpdateSearch">
							<option :value="null">{{ $t("any") }}</option>
							<option v-for="programme in $config.getValue('programmes')" :key="programme.Id"
								:value="programme">{{ programme.Name }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("year") }}</label>
						<select class="form-control" v-model="search.year" @change="callUpdateSearch">
							<option :value="null">{{ $t("any") }}</option>
							<template v-if="search.programme">
								<option v-for="year in parseInt(search.programme.CourseLengthYears)" :key="year"
									:value="year">{{ year }}
								</option>
								<option :value="parseInt(search.programme.CourseLengthYears) + 1">{{ $t('graduated') }}
								</option>
							</template>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("group") }}</label>
						<select class="form-control" v-model="search.group" @change="callUpdateSearch">
							<option :value="null">{{ $t("any") }}</option>
							<option v-for="(name, id) in $config.getValue('groups')" :key="id" :value="id">{{ name }}
							</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div class="clearfix mb-2">
			<h2 class="float-left">
				<template>
					{{ $t('third-party-data') }}
				</template>
			</h2>
			<div class="text-right float-right" v-if="loaded">
				<div class="form-inline">
					<router-link to="/thirdparty/upload">
						<button class="btn btn-outline-secondary float-right mr-2" data-cy="upload-file-button"
							v-if="$UserSession.hasPriv('ASSETS_UPLOAD')">
							<b-icon icon="plus" class="mr-1" />
							{{ $t("upload") }}
						</button>
					</router-link>
					<button class="btn btn-outline-secondary mr-2" v-on:click="toggleAdvancedSearch()">
						{{ $t("filter") }}
					</button>
					<span class="input-group mr-2">
						<input type="text" class="form-control" :placeholder="$t('column-name')"
							:aria-label="$t('column-name')" aria-describedby="basic-addon2" v-model="newColumnName">
						<span class="input-group-append">
							<button class="btn btn-outline-secondary" type="button"
								@click="addColumn(newColumnName)">{{ $t('add-column') }}</button>
						</span>
					</span>
					<button class="btn btn-primary" @click="saveTransferData(datatransfer.data,datatransfer.cols)">{{ $t('save') }}</button>
				</div>
			</div>
		</div>
		<div class="sticky-container" v-if="loaded">
			<table class="table table-bordered table-timetable" :class="tableClass" :key="tableKey">
				<thead>
					<tr>
						<th>{{ $t('name') }}</th>
						<th v-for="(datapoint, index) in datatransfer.cols" :key="index"
							@contextmenu.prevent="editMenu(datapoint)">
                            <div class="d-flex align-items-center justify-content-between">
                                {{ datapoint.caption }}
                                <b-icon icon="calendar-event" v-if="datapoint.datatype == 1"></b-icon>
                            </div>    
						</th>
					</tr>
				</thead>
				<tbody>
					<template v-for="student in filteredStudents">
						<tr :key="student.id">
							<td>{{student.displayName}}</td>
							<td v-for="(datapoint,index) in datatransfer.cols" :key="index" style="	min-width: 35px; ">
								<template v-if="datatransfer.data && student.id in datatransfer.data && datapoint.id in datatransfer.data[student.id]">
									 <input
                                        :type="(datapoint.datatype == 0 || datapoint.datatype == null)  ? 'number' : 'datetime-local'"
                                        :step="1" 
                                        class="td-input" 
                                        v-model="datatransfer.data[student.id][datapoint.id][(datapoint.datatype == 0 || datapoint.datatype == null)  ? 'value' : 'datetime']"
                                    />
								</template>
							</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>

		<template v-else>
			<div>
				<div class="skeleton midnight h20 w100 mr-4 mb-3 float-left" v-for="n in 100" :key="n"></div>
			</div>
		</template>

		<div class="context-menu-mask" v-show="viewMenu" @click="closeMenu">
			<div class="context-menu" id="context-menu" :style="{ top: top, left: left }">
				<ul>
					<li class="context-menu-btn primary" @click="datatransfer.cols[colid].datatype = 0 ">{{ $t('datatype-integer') }}</li>
					<li class="context-menu-btn primary" @click="datatransfer.cols[colid].datatype = 1 ">{{ $t('datatype-datetime') }}</li>
					<li class="context-menu-btn danger" @click="deleteColumn(colid)">{{ $t('delete-column') }}</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	},
	data() {
		return {
			zoom: 3,
			loaded: false,
			groups: [],
			timetable: [],
			replace: false,
			viewMenu: false,
			top: 0,
			left: 0,
			datatransfer: {
				cols: {},
				data: {}
			},
			students: [],
			newColumnName: '',
			showadvancedsearch: false,
			search: {
				q: "",
				programme: null,
				year: null,
				group: null,
			},
			updatedQuery: null,
			tableKey: 0,
            col:{},
            datatype:{}
		}
	},
	mounted() {
		if (this.isNew) {
			this.loaded = true;
		} else {
			this.loadValues();
		}
		this.$users.getStudents.call(this).then(students => {
			this.students = students;
		})
	},
	methods: {
		callUpdateSearch: function () {
			this.updateSearch;
		},
		hydrate: function () {
			for (var index in this.datatransfer.cols) {
				this.hydrateCol(this.datatransfer.cols[index].id);
            }
		},
		hydrateCol: function (colid) {
			/*  This initializes data for a table as it ensures that each student has an entry for a given column ID.*/
			this.$users.getStudents.call(this).then(students => {/*Calls the getStudents method of an object referred to by this.$users, which is expected to return a promise.
                When the Promise is resolved, the method receives an array of students.*/
				students.forEach(student => {

					if (student.id!=='' && !(student.id in this.datatransfer.data)) {
						/*For each student, it checks whether the id property of the student is present in this.datatransfer. If not,
						it adds an empty object to the data object for the student's id property using this.$set.*/

						this.$set(this.datatransfer.data, student.id, {});
					}
					if (!(colid in this.datatransfer.data[student.id])) {
						/*Next, it checks whether the colid parameter is present in student.id. If not,
						 it adds a null value to the data object for the student's id property and the colid property using this.$set.*/
						this.$set(this.datatransfer.data[student.id], colid, {
                                'value': null,
                                'datetime': null
                            }
                        );
                       
					}
				});
			})
            
		},
		checkRepeatedColName: function (input) {
			for (let index in this.datatransfer.cols) {
				if (input === this.datatransfer.cols[index].name) {
					return true;
				}
			}
		},
		checkBlankColName: function (input) {
			if (input === '-' || input === '') {
				return true;
			}
			else {
				return false;
			}
		},
		addColumn(input) {
			var name = input.toLowerCase().trim().replace(/[^a-z0-9]+/g, '_').replace(/^_+/, '').replace(/_+$/, '');
			if (this.checkRepeatedColName(name)) {
				this.$store.commit("openDialog", {
					title: this.$t("oops"),
					content: this.$t("column-name-already-in-use")
				});
			}
			else if (this.checkBlankColName(name)) {
				this.$store.commit("openDialog", {
					title: this.$t("oops"),
					content: this.$t("the-name-can-not-be-empty")
				});
			}
			else {
				this.$cfetch(`${this.$settings.APIBaseURL}/thirdpartydata/save`, {
					data: {
						id: null,
						name: name,
						caption: input
					},
					method: 'post'
				}).then((res) => {
					if (res.status === "SUCCESS") {
						this.$set(this.datatransfer.cols, res.result.id, res.result);
						this.hydrate();
					} else {
						if (res.error_message) {
							this.error = res.error_message;
						} else {
							this.error = this.$t("failed-load-table");
						}
					}
				});
			}
		},
		loadValues: function () {
			this.$cfetch(`${this.$settings.APIBaseURL}/thirdpartydata/getvalues`, {
				data: {
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.datatransfer = res.result;
					this.hydrate();
					this.loaded = true;
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-load-table");
					}
				}
			});
		},
		saveTransferData(values,columns) {
            let datatype = {};

            for(let colid in columns){
                datatype[colid] = columns[colid].datatype
            }

            for(let userid in values){
                for(let colid in values[userid]){
                    if(values[userid][colid].datetime !== null) {
                        const dateObj = new Date(values[userid][colid].datetime);
                        values[userid][colid].datetime = this.formatDatetimeToYmdHis(dateObj);
                    }
                }
            }

			this.$cfetch(`${this.$settings.APIBaseURL}/thirdpartydata/savevalues`, {
				method: 'post',
				data: {
					values: values,
                    datatype: datatype
				}
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.$store.commit("openDialog", {
						title: this.$t("save"),
						content: this.$t("the-table-was-succesfully-saved")
					});
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-to-save-values");
					}
				}
			});
		},
		toggleAdvancedSearch() {
			if (this.showadvancedsearch) {
				this.showadvancedsearch = false;
				this.setSearchDefaults();
			} else {
				this.showadvancedsearch = true;
			}
		},
		setSearchDefaults() {
			this.search = {
				q: "",
				programme: null,
				year: null,
				group: null
			};
		},
		deleteColumn(colid) {
			this.$store.commit("openDialog", {
				cancelBtn: true,
				title: this.$t("delete-column"),
				content: this.$t("delete-column-dialog"),
				confirmCallBack: function () {
					this.$cfetch(`${this.$settings.APIBaseURL}/thirdpartydata/delete`, {
						data: {
							id: colid
						},
						method: 'post'
					}).then((res) => {
						if (res.status === "SUCCESS") {
							this.loadValues();
						}
						else {
							console.log(`The column with id: ${colid} was NOT deleted`)
						}
					});
				}.bind(this),
			});
		},
		setMenu: function (itop, ileft) {

			var top = itop;
			var left = ileft;

			let width = 280;
			let height = 220;
			var largestHeight = window.innerHeight - (height + 20);
			var largestWidth = window.innerWidth - (width + 20);

			if (top > largestHeight) top = top - (height + 20);
			if (left > largestWidth) left = left - (width + 20);

			this.top = top + 'px';
			this.left = left + 'px';

			var self = this;
			window.setTimeout(function () {

				let width = 280;
				let height = 220;
				let menu = document.getElementById('context-menu');
				if (menu) {
					width = menu.offsetWidth;
					height = menu.clientHeight;
				}

				var largestHeight = window.innerHeight - (height + 20);
				var largestWidth = window.innerWidth - (width + 20);

				if (top > largestHeight) top = top - (height + 20);
				if (left > largestWidth) left = left - (width + 20);

				self.top = top + 'px';
				self.left = left + 'px';

			}, 10);
		},
		closeMenu: function () {
			this.viewMenu = false;
		},
		editMenu: function (col) {
            this.col = col
			this.colid = col.id;
			this.viewMenu = true;
			this.setMenu(event.clientY, event.clientX + 10, this.col.id);
		},
        isValidDateTime(datetimeString) {
            // Regular expression for "yyyy-mm-dd hh:mm:ss" 
            const datetimeRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
            const excelRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
            const jsRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
            return datetimeRegex.test(datetimeString) || excelRegex.test(datetimeString) 
                || dateRegex.test(datetimeString) || jsRegex.test(datetimeString);
        },
        formatDatetimeToYmdHis(inputDate) {
            // Ensure that the inputDate is a Date object
            if (!(inputDate instanceof Date)) {
                inputDate = new Date(inputDate);
            }

            // Get individual components
            const year = inputDate.getFullYear();
            const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Because months are zero-based
            const day = String(inputDate.getDate()).padStart(2, '0');
            const hours = String(inputDate.getHours()).padStart(2, '0');
            const minutes = String(inputDate.getMinutes()).padStart(2, '0');
            const seconds = String(inputDate.getSeconds()).padStart(2, '0');

            // Format the date string
            const formattedDate = hours !== '00' || minutes !== '00' || seconds !== '00'
                ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
                : `${year}-${month}-${day}`;

            return formattedDate;
        }
	},
	computed: {
		tableClass: function () {
			if (this.zoom == 2) {
				return 'table-timetable-sm';
			}
			if (this.zoom == 1) {
				return 'table-timetable-xs';
			}
			return '';
		},
		updateSearch: function () {
			var updatedQuery = this.search;
			localStorage.setItem('cafs_tpd_savedsearch', JSON.stringify(updatedQuery));
			if (this.search) {
				updatedQuery = {
					programme: this.search.programme ? this.search.programme.Id : "",
					year: this.search.year ? this.search.year : "",
					group: this.search.group ? this.search.group : ""
				};
			}
			return updatedQuery;
		},
		filteredStudents: function () {
			let filtered = this.students;
			let prog = this.updateSearch.programme;
			let year = this.updateSearch.year;
			let group = this.updateSearch.group;
			if (prog) {
				filtered = filtered.filter(item => item.programme === prog);
			}
			if (year && year.toString()) {
				filtered = filtered.filter(item => item.year === year.toString());
			}
			if (group) {
				filtered = filtered.filter(item => item.group === group);
			}
			return filtered;

		},

	}
};
</script>
